import TableRow from "./TableRow";
const TableBody = ({ rows, prepareRow, onClick, rowClassName = "" }) => {
  return (
    <div className="table-body-container"
      style={{}}>
      {rows.map((row, index) => {
        prepareRow(row);
        return <TableRow row={row} onClick={onClick} key={index}
          className={rowClassName ? rowClassName(row) : ""}
        />;
      })}
    </div>
  );
};

export default TableBody;
